"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSelector = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_select_1 = require("../../components/input/input.select");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_state_1 = require("../../state/page.state");
const collection_status_modal_style_1 = require("./collection.status.modal.style");
const status_selector_ctrl_1 = require("./status.selector.ctrl");
class StatusSelector extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        this.ctrl = new status_selector_ctrl_1.StatusSelectorCtrl();
        this.inputState = new input_select_1.SelectInputState(i18n_1.T.STATUS);
        this.inputState.isRequired = false;
        this.reaction(() => this.inputState.value, status => this.ctrl.selectStatus(status), { fireImmediately: true });
        this.reaction(() => this.ctrl.statusOptions, options => {
            this.inputState.setOptions(options);
            this.inputState.setValue(null);
        }, { fireImmediately: true });
    }
    get nodes() {
        if (this.inputState == null) {
            return null;
        }
        if (this.ctrl.loadingStatuses) {
            return spinner_1.Spinner.view();
        }
        return input_select_1.SelectInputComponent.view(this.inputState);
    }
    selectedStats() {
        if (!this.ctrl.selectedStatus) {
            return null;
        }
        let count = 0;
        for (const stats of this.ctrl.allStatuses) {
            if (stats.statuses.indexOf(this.selectedStatus) > -1) {
                count++;
            }
        }
        return (0, mithril_1.m)('ul', { className: collection_status_modal_style_1.CSS.list }, [
            (0, mithril_1.m)('li', this.selectedStatus + ': ' + count),
            (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_STATUS_CANNOT_CHANGE, { count: page_state_1.CurrentState.Tag.collections.length - count }))
        ]);
    }
    get selectedStatus() {
        return this.ctrl.selectedStatus;
    }
}
exports.StatusSelector = StatusSelector;
tslib_1.__decorate([
    mobx_1.computed
], StatusSelector.prototype, "selectedStatus", null);
//# sourceMappingURL=status.selector.js.map